// extracted by mini-css-extract-plugin
module.exports = {"bgText":"terms_bgText__1xMu-","texSection":"terms_texSection__2-uDw","policyText":"terms_policyText__2dSoj","banner":"terms_banner__R52C-","textContant":"terms_textContant__3Dw50"};